import React, { useState, useEffect, useRef, useCallback } from 'react';
import ws from './../../../utils/Socket';
import Map from './Map';
import truck from '../../../assets/img/truck-icon.png'
import swal from 'sweetalert';

import './index.css'

function MapTracker({ localizatorCod, travelDetails }) {
  const [tracker, setTracker] = useState(null);
  const [centerMap, setCenterMap] = useState(null)
  const [trackerCoords, setTrackerCoords] = useState(null);
  const [travel, setTravel] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);
  const [directionsService, setDirectionsService] = useState(null);

  const initialCoords = useRef([-15.77972, -47.92972]); //coordenadas de bsb

  let mapProps = {
    options: {
      center: {
        lat: initialCoords[0],
        lng: initialCoords[1]
      },
      zoom: 12,
      maxZoom: 20
    },
    onMount: getMap,
  }

  const MemoMap = useCallback(<Map {...mapProps} />, [travel]);

  useEffect(() => {
    console.log(travelDetails)
    setTravel(travelDetails)
    init(travelDetails._id)
  }, [travelDetails])

  useEffect(() => {
    if (trackerCoords && tracker) {
      tracker.setMap(null)
    }
    if (directionsRenderer !== null) {
      directionsRenderer.setMap(null);
      setDirectionsRenderer(null);
    }
    setDirectionsRenderer(new window.google.maps.DirectionsRenderer())
    setDirectionsService(new window.google.maps.DirectionsService())
  }, [localizatorCod])

  useEffect(() => {
    if (travel) {
      initRoute(travel, centerMap)
    }
  }, [travel])

  useEffect(() => {
    if (centerMap) {
      directionsRenderer.setMap(centerMap);
    }
  }, [centerMap])

  useEffect(() => {
    if (trackerCoords && tracker) {
      markers(centerMap)
      tracker.setPosition(new window.google.maps.LatLng(trackerCoords[0], trackerCoords[1]))
      centerMap.setCenter(tracker.position)
      centerMap.setZoom(15);
    }
  }, [trackerCoords])

  async function init(cod) {
    ws.connect();
    travel && closeSocketSubscription(travel._id);
    const socket = ws.getSubscription('travel-location-logs:' + cod)
    if (!socket) {
      console.log('conectando', socket)
      ws.subscribe('travel-location-logs:' + cod)
      ws.getSubscription('travel-location-logs:' + cod).on('message', message => {
        setTrackerCoords(message.location)
        console.log(message)
      });
    }
  }

  function closeSocketSubscription(cod) {
    console.log('close ' + 'travel-location-logs:' + cod);
    console.log('close ' + 'travel-logs:' + cod);
    const travelTopic = 'travel-location-logs:' + cod;
    const deviceTopic = 'travel-logs:' + cod;
    const socketTravel = ws.getSubscription(travelTopic);
    const socketDevice = ws.getSubscription(deviceTopic);
    console.log(socketTravel)
    console.log(socketDevice)
    if (socketTravel && socketDevice) {
      socketTravel.close();
      socketDevice.close();
    }
  }

  function markers(map) {
    if (travelDetails.last_position) {
      if (travelDetails.last_position[0] && travelDetails.last_position[1]) {
        setTracker(new window.google.maps.Marker({
          map,
          position: { lat: travelDetails.last_position[0], lng: travelDetails.last_position[1] },
          animation: window.google.maps.Animation.DROP,
          icon: {
            url: truck,
            scaledSize: new window.google.maps.Size(50, 40)
          }
        }));
      }
    }
  }

  function initRoute(route, map) {
    directionsService.route(
      {
        origin: { lat: route.origin.location[0], lng: route.origin.location[1] },
        destination: { lat: route.destiny.location[0], lng: route.destiny.location[1] },
        travelMode: window.google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          directionsRenderer.setDirections(result);
          directionsRenderer.setMap(map);
        } else {
          console.error(`error fetching directions ${result}`);
          swal("Erro!", "Não foi possível traçar esse trajeto", "error");
        }
      }
    );
  }

  function getMap(map) {
    setCenterMap(map)
    directionsService.route(
      {
        origin: { lat: travel.origin.location[0], lng: travel.origin.location[1] },
        destination: { lat: travel.destiny.location[0], lng: travel.destiny.location[1] },
        travelMode: window.google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          directionsRenderer.setDirections(result);
          directionsRenderer.setMap(map);
        } else {
          console.error(`error fetching directions ${result}`);
          swal("Erro!", "Não foi possível traçar esse trajeto", "error");
        }
      }
    );
    markers(map)
  }

  function renderPending() {
    return (
      <div className="overlay">
        <div className="alert">
          <h1>Trajeto não selecionado</h1>
        </div>
      </div>
    );
  }

  function renderStatus(status) {
    switch (status) {
      case 0:
        return (
          <span className="localizator-status notStarted">
            Viagem não iniciada
          </span>
        )
      case 1:
        return (
          <span className="localizator-status pending">
            Viagem em andamento
          </span>
        )
      case 2:
        return (
          <span className="localizator-status finalized">
            Viagem finalizada
          </span>
        )
      case 3:
        return (
          <span className="localizator-status paused">
            Viagem pausada
          </span>
        )
      default:
        break;
    }
  }

  return (
    <div className="MapTracker">
      {travel ?
        <>
          {renderStatus(travelDetails.status)}
          {directionsRenderer && MemoMap}
        </>
        :
        renderPending()
      }
    </div>
  )
}

export default MapTracker;